// Arquivo gerado automaticamente.

import visual15 from '../assets/questoes-visuais/matematica/15.webp';
import visual27 from '../assets/questoes-visuais/matematica/27.webp';
import visual33 from '../assets/questoes-visuais/matematica/33.webp';
import visual44 from '../assets/questoes-visuais/matematica/44.webp';
import visual84 from '../assets/questoes-visuais/matematica/84.webp';
import visual92 from '../assets/questoes-visuais/matematica/92.webp';
import visual102 from '../assets/questoes-visuais/matematica/102.webp';
import visual109 from '../assets/questoes-visuais/matematica/109.webp';
import visual115 from '../assets/questoes-visuais/matematica/115.webp';
import visual134 from '../assets/questoes-visuais/matematica/134.webp';
import visual136 from '../assets/questoes-visuais/matematica/136.webp';
import visual138 from '../assets/questoes-visuais/matematica/138.webp';
import visual142 from '../assets/questoes-visuais/matematica/142.webp';
import visual181 from '../assets/questoes-visuais/matematica/181.webp';
import visual182 from '../assets/questoes-visuais/matematica/182.webp';
import visual242 from '../assets/questoes-visuais/matematica/242.webp';
import visual269 from '../assets/questoes-visuais/matematica/269.webp';
import visual288 from '../assets/questoes-visuais/matematica/288.webp';
import visual303 from '../assets/questoes-visuais/matematica/303.webp';
import visual315 from '../assets/questoes-visuais/matematica/315.webp';
import visual333 from '../assets/questoes-visuais/matematica/333.webp';
import visual336 from '../assets/questoes-visuais/matematica/336.webp';
import visual345 from '../assets/questoes-visuais/matematica/345.webp';
import visual349 from '../assets/questoes-visuais/matematica/349.webp';
import visual350 from '../assets/questoes-visuais/matematica/350.webp';
import visual386 from '../assets/questoes-visuais/matematica/386.webp';
import visual405 from '../assets/questoes-visuais/matematica/405.webp';
import visual421 from '../assets/questoes-visuais/matematica/421.webp';
import visual424 from '../assets/questoes-visuais/matematica/424.webp';
import visual434 from '../assets/questoes-visuais/matematica/434.webp';
import visual450 from '../assets/questoes-visuais/matematica/450.webp';
import visual463 from '../assets/questoes-visuais/matematica/463.webp';
import visual477 from '../assets/questoes-visuais/matematica/477.webp';
import visual503 from '../assets/questoes-visuais/matematica/503.webp';
import visual504 from '../assets/questoes-visuais/matematica/504.webp';
import visual520 from '../assets/questoes-visuais/matematica/520.webp';
import visual525 from '../assets/questoes-visuais/matematica/525.webp';
import visual542 from '../assets/questoes-visuais/matematica/542.webp';
import visual543 from '../assets/questoes-visuais/matematica/543.webp';
import visual598 from '../assets/questoes-visuais/matematica/598.webp';
import visual599 from '../assets/questoes-visuais/matematica/599.webp';
import visual616 from '../assets/questoes-visuais/matematica/616.webp';
import visual624 from '../assets/questoes-visuais/matematica/624.webp';
import visual633 from '../assets/questoes-visuais/matematica/633.webp';
import visual652 from '../assets/questoes-visuais/matematica/652.webp';
import visual665 from '../assets/questoes-visuais/matematica/665.webp';
import visual706 from '../assets/questoes-visuais/matematica/706.webp';
import visual757 from '../assets/questoes-visuais/matematica/757.webp';
import visual763 from '../assets/questoes-visuais/matematica/763.webp';
import visual779 from '../assets/questoes-visuais/matematica/779.webp';
import visual790 from '../assets/questoes-visuais/matematica/790.webp';
import visual824 from '../assets/questoes-visuais/matematica/824.webp';
import visual827 from '../assets/questoes-visuais/matematica/827.webp';
import visual847 from '../assets/questoes-visuais/matematica/847.webp';
import visual850 from '../assets/questoes-visuais/matematica/850.webp';
import visual881 from '../assets/questoes-visuais/matematica/881.webp';
import visual884 from '../assets/questoes-visuais/matematica/884.webp';
import visual923 from '../assets/questoes-visuais/matematica/923.webp';
import visual939 from '../assets/questoes-visuais/matematica/939.webp';
import visual941 from '../assets/questoes-visuais/matematica/941.webp';
import visual949 from '../assets/questoes-visuais/matematica/949.webp';
import visual958 from '../assets/questoes-visuais/matematica/958.webp';
import visual973 from '../assets/questoes-visuais/matematica/973.webp';
import visual985 from '../assets/questoes-visuais/matematica/985.webp';
import visual991 from '../assets/questoes-visuais/matematica/991.webp';
import visual1004 from '../assets/questoes-visuais/matematica/1004.webp';
import visual1019 from '../assets/questoes-visuais/matematica/1019.webp';
import visual1025 from '../assets/questoes-visuais/matematica/1025.webp';
import visual1029 from '../assets/questoes-visuais/matematica/1029.webp';
import visual1033 from '../assets/questoes-visuais/matematica/1033.webp';
import visual1034 from '../assets/questoes-visuais/matematica/1034.webp';
import visual1035 from '../assets/questoes-visuais/matematica/1035.webp';
import visual7 from '../assets/questoes-visuais/matematica/7.webp';
import visual10 from '../assets/questoes-visuais/matematica/10.webp';
import visual46 from '../assets/questoes-visuais/matematica/46.webp';
import visual52 from '../assets/questoes-visuais/matematica/52.webp';
import visual53 from '../assets/questoes-visuais/matematica/53.webp';
import visual54 from '../assets/questoes-visuais/matematica/54.webp';
import visual56 from '../assets/questoes-visuais/matematica/56.webp';
import visual63 from '../assets/questoes-visuais/matematica/63.webp';
import visual68 from '../assets/questoes-visuais/matematica/68.webp';
import visual69 from '../assets/questoes-visuais/matematica/69.webp';
import visual93 from '../assets/questoes-visuais/matematica/93.webp';
import visual96 from '../assets/questoes-visuais/matematica/96.webp';
import visual101 from '../assets/questoes-visuais/matematica/101.webp';
import visual103 from '../assets/questoes-visuais/matematica/103.webp';
import visual105 from '../assets/questoes-visuais/matematica/105.webp';
import visual106 from '../assets/questoes-visuais/matematica/106.webp';
import visual122 from '../assets/questoes-visuais/matematica/122.webp';
import visual123 from '../assets/questoes-visuais/matematica/123.webp';
import visual124 from '../assets/questoes-visuais/matematica/124.webp';
import visual126 from '../assets/questoes-visuais/matematica/126.webp';
import visual131 from '../assets/questoes-visuais/matematica/131.webp';
import visual148 from '../assets/questoes-visuais/matematica/148.webp';
import visual156 from '../assets/questoes-visuais/matematica/156.webp';
import visual158 from '../assets/questoes-visuais/matematica/158.webp';
import visual164 from '../assets/questoes-visuais/matematica/164.webp';
import visual170 from '../assets/questoes-visuais/matematica/170.webp';
import visual204 from '../assets/questoes-visuais/matematica/204.webp';
import visual229 from '../assets/questoes-visuais/matematica/229.webp';
import visual268 from '../assets/questoes-visuais/matematica/268.webp';
import visual299 from '../assets/questoes-visuais/matematica/299.webp';
import visual301 from '../assets/questoes-visuais/matematica/301.webp';
import visual304 from '../assets/questoes-visuais/matematica/304.webp';
import visual321 from '../assets/questoes-visuais/matematica/321.webp';
import visual325 from '../assets/questoes-visuais/matematica/325.webp';
import visual327 from '../assets/questoes-visuais/matematica/327.webp';
import visual340 from '../assets/questoes-visuais/matematica/340.webp';
import visual343 from '../assets/questoes-visuais/matematica/343.webp';
import visual354 from '../assets/questoes-visuais/matematica/354.webp';
import visual356 from '../assets/questoes-visuais/matematica/356.webp';
import visual366 from '../assets/questoes-visuais/matematica/366.webp';
import visual369 from '../assets/questoes-visuais/matematica/369.webp';
import visual374 from '../assets/questoes-visuais/matematica/374.webp';
import visual382 from '../assets/questoes-visuais/matematica/382.webp';
import visual385 from '../assets/questoes-visuais/matematica/385.webp';
import visual389 from '../assets/questoes-visuais/matematica/389.webp';
import visual392 from '../assets/questoes-visuais/matematica/392.webp';
import visual404 from '../assets/questoes-visuais/matematica/404.webp';
import visual411 from '../assets/questoes-visuais/matematica/411.webp';
import visual422 from '../assets/questoes-visuais/matematica/422.webp';
import visual427 from '../assets/questoes-visuais/matematica/427.webp';
import visual496 from '../assets/questoes-visuais/matematica/496.webp';
import visual529 from '../assets/questoes-visuais/matematica/529.webp';
import visual553 from '../assets/questoes-visuais/matematica/553.webp';
import visual604 from '../assets/questoes-visuais/matematica/604.webp';
import visual618 from '../assets/questoes-visuais/matematica/618.webp';
import visual619 from '../assets/questoes-visuais/matematica/619.webp';
import visual620 from '../assets/questoes-visuais/matematica/620.webp';
import visual622 from '../assets/questoes-visuais/matematica/622.webp';
import visual626 from '../assets/questoes-visuais/matematica/626.webp';
import visual630 from '../assets/questoes-visuais/matematica/630.webp';
import visual653 from '../assets/questoes-visuais/matematica/653.webp';
import visual695 from '../assets/questoes-visuais/matematica/695.webp';
import visual712 from '../assets/questoes-visuais/matematica/712.webp';
import visual731 from '../assets/questoes-visuais/matematica/731.webp';
import visual797 from '../assets/questoes-visuais/matematica/797.webp';
import visual798 from '../assets/questoes-visuais/matematica/798.webp';
import visual814 from '../assets/questoes-visuais/matematica/814.webp';
import visual853 from '../assets/questoes-visuais/matematica/853.webp';
import visual876 from '../assets/questoes-visuais/matematica/876.webp';
import visual893 from '../assets/questoes-visuais/matematica/893.webp';
import visual927 from '../assets/questoes-visuais/matematica/927.webp';
import visual962 from '../assets/questoes-visuais/matematica/962.webp';
import visual1024 from '../assets/questoes-visuais/matematica/1024.webp';

export const matematicaEnemVisualLocalMap: Record<number, string> = {
  15: visual15,
  27: visual27,
  33: visual33,
  44: visual44,
  84: visual84,
  92: visual92,
  102: visual102,
  109: visual109,
  115: visual115,
  134: visual134,
  136: visual136,
  138: visual138,
  142: visual142,
  181: visual181,
  182: visual182,
  242: visual242,
  269: visual269,
  288: visual288,
  303: visual303,
  315: visual315,
  333: visual333,
  336: visual336,
  345: visual345,
  349: visual349,
  350: visual350,
  386: visual386,
  405: visual405,
  421: visual421,
  424: visual424,
  434: visual434,
  450: visual450,
  463: visual463,
  477: visual477,
  503: visual503,
  504: visual504,
  520: visual520,
  525: visual525,
  542: visual542,
  543: visual543,
  598: visual598,
  599: visual599,
  616: visual616,
  624: visual624,
  633: visual633,
  652: visual652,
  665: visual665,
  706: visual706,
  757: visual757,
  763: visual763,
  779: visual779,
  790: visual790,
  824: visual824,
  827: visual827,
  847: visual847,
  850: visual850,
  881: visual881,
  884: visual884,
  923: visual923,
  939: visual939,
  941: visual941,
  949: visual949,
  958: visual958,
  973: visual973,
  985: visual985,
  991: visual991,
  1004: visual1004,
  1019: visual1019,
  1025: visual1025,
  1029: visual1029,
  1033: visual1033,
  1034: visual1034,
  1035: visual1035,
  7: visual7,
  10: visual10,
  46: visual46,
  52: visual52,
  53: visual53,
  54: visual54,
  56: visual56,
  63: visual63,
  68: visual68,
  69: visual69,
  93: visual93,
  96: visual96,
  101: visual101,
  103: visual103,
  105: visual105,
  106: visual106,
  122: visual122,
  123: visual123,
  124: visual124,
  126: visual126,
  131: visual131,
  148: visual148,
  156: visual156,
  158: visual158,
  164: visual164,
  170: visual170,
  204: visual204,
  229: visual229,
  268: visual268,
  299: visual299,
  301: visual301,
  304: visual304,
  321: visual321,
  325: visual325,
  327: visual327,
  340: visual340,
  343: visual343,
  354: visual354,
  356: visual356,
  366: visual366,
  369: visual369,
  374: visual374,
  382: visual382,
  385: visual385,
  389: visual389,
  392: visual392,
  404: visual404,
  411: visual411,
  422: visual422,
  427: visual427,
  496: visual496,
  529: visual529,
  553: visual553,
  604: visual604,
  618: visual618,
  619: visual619,
  620: visual620,
  622: visual622,
  626: visual626,
  630: visual630,
  653: visual653,
  695: visual695,
  712: visual712,
  731: visual731,
  797: visual797,
  798: visual798,
  814: visual814,
  853: visual853,
  876: visual876,
  893: visual893,
  927: visual927,
  962: visual962,
  1024: visual1024,
};
